import TotalUser from './TotalUser';

export default TotalUser;
